import * as Sentry from '@sentry/react'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://2a808a505f103c901a501a7296533b5a@o372772.ingest.us.sentry.io/4510195142885376',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    beforeSend: (event) => {
      if (process.env.NODE_ENV !== 'production') {
        console.error(event)
        return null // this drops the event and nothing will be send to sentry
      }
      return event
    },
    integrations: (integrations) => [
      ...integrations,
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
      Sentry.feedbackIntegration({
        // We don't want to automatically inject the feedback form into the page
        // because we want to control when it appears after the user logs in
        autoInject: false,
        colorScheme: 'dark',
        submitButtonLabel: 'Send',
        triggerLabel: 'Submit Feedback',
        triggerAriaLabel: 'Submit Feedback',
        formTitle: 'User Feedback',
        messagePlaceholder: 'Tell us what we could do better',
      }),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
    // Enable logs to be sent to Sentry
    enableLogs: true,
  })
}
